export const AGENT_CONFIG = {
    requests: {
        getAgents: {
            url: `agents`,
        },
        getCustomers: {
            url: `customers`,
        },
        getCustomerTypes: {
            url: `customertypes`,
        },
        downloadFile: {
            url: `download-file`,
        },
        removeFiles: {
            url: `remove-files`,
        },

     
    },
};
